import Phaser from 'phaser';
import Background, {
  preload as preloadBackground,
} from '../../objects/test/Background';
import Player, { preload as preloadPlayer } from '../../objects/test/Player';

export default class UncontrolledPlayer extends Phaser.Scene {
  constructor() {
    super({ key: 'UncontrolledPlayer', active: true });
  }

  preload() {
    this.load.setBaseURL('/assets/test/');

    preloadBackground.call(this, 'background_flat', '1.png');
    preloadBackground.call(this, 'background_trees', '3.png');
    preloadBackground.call(this, 'background_spiders', '4.png');
    preloadBackground.call(this, 'background_ground', 'ground.png');

    preloadPlayer.call(this);
  }

  create() {
    // BACKGROUND
    this.background_flat = new Background({
      scene: this,
      x: 0,
      y: this.game.config.height,
      width: 0, // If zero it will use the size of the texture frame.
      height: 0, // If zero it will use the size of the texture frame.
      key: 'background_flat',
    });
    this.background_trees = new Background({
      scene: this,
      x: 0,
      y: this.game.config.height,
      width: 0, // If zero it will use the size of the texture frame.
      height: 0, // If zero it will use the size of the texture frame.
      key: 'background_trees',
    });
    this.background_spiders = new Background({
      scene: this,
      x: 0,
      y: this.game.config.height,
      width: 0, // If zero it will use the size of the texture frame.
      height: 0, // If zero it will use the size of the texture frame.
      key: 'background_spiders',
    });
    this.background_ground = new Background({
      scene: this,
      x: 0,
      y: this.game.config.height,
      width: 0, // If zero it will use the size of the texture frame.
      height: 0, // If zero it will use the size of the texture frame.
      key: 'background_ground',
      usePhysics: true,
    });

    this.physics.add.existing(this.background_ground);
    this.background_ground.body.setSize(this.game.config.width * 5, 100);
    this.background_ground.body.setAllowGravity(false);
    this.background_ground.body.immovable = true;

    // PLAYER
    this.player = new Player({
      scene: this,
      x: 200,
      y: this.game.config.height - 60,
    });
    this.player.setOrigin(0.5, 1);
    this.player.body.setCollideWorldBounds(true);

    // PHYSICS
    this.physics.add.collider(this.player, this.background_ground);

    // CAMERA
    this.cameras.main.setBounds(
      0,
      0,
      this.game.config.width * 3,
      this.game.config.height
    );
    this.cameras.main.startFollow(this.player, true, 0.05, 0.05);

    // TIMELINE
    const timeline = this.tweens.createTimeline();

    // 0 - 3000
    this.cameras.main.fadeIn(3000);

    timeline.add({
      targets: this.player,
      alpha: 1,
      duration: 2000,
      delay: 2000,
      onStart: () => {
        this.player.move({
          speed: 300,
        });
      },
      onComplete: () => {
        this.player.stop();
        this.cameras.main.zoomTo(0.9, 1000, 'Power1');
      },
    });

    timeline.add({
      targets: this.player,
      alpha: 1,
      duration: 1000,
      delay: 1000,
      onStart: () => {
        // this.cameras.main.stopFollow();
        this.player.move({
          direction: 'left',
          speed: 200,
        });
      },
      onComplete: () => {
        this.player.stop();
        this.cameras.main.zoomTo(1.2, 1000, 'Power1');
      },
    });

    timeline.add({
      targets: this.player,
      alpha: 1,
      duration: 2000,
      delay: 1000,
      onStart: () => {
        this.player.move({
          speed: 100,
        });
      },
      onComplete: () => {
        this.cameras.main.fadeOut(2000);
      },
    });

    timeline.play();
  }

  update(time, delta) {
    this.background_trees.tilePositionX = this.cameras.main.scrollX * 0.4;
    this.background_spiders.tilePositionX = this.cameras.main.scrollX * 0.7;
    this.background_ground.tilePositionX = this.cameras.main.scrollX * 1;
  }
}
